module.exports = __webpack_public_path__ + "static/media/dailyActivityActive.06455537.svg";